import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@ontruck/orc';
import { Trans } from 'react-i18next';

import Modal from 'components/layout/Modal';

const AddressDeleteModal = ({
  className,

  handleClose,
  company_name,
  label,
  t,

  handleDelete,
}) => (
  <Modal
    show
    size="S"
    title={<p className="title">{t('cancel_title')}</p>}
    onClose={handleClose}
  >
    <form className={className} autoComplete="off">
      <Trans
        t={t}
        i18nKey="cancel_info"
        values={{ address: `${company_name} - ${label}` }}
        components={[<b> {`${company_name} - ${label}`}</b>]}
      />

      <div className="button-container">
        <Button onClick={handleClose} text={t('cancel')} ghost skin="primary" />
        <div className="cancel-btn">
          <Button onClick={handleDelete} text={t('delete_btn')} />
        </div>
      </div>
    </form>
  </Modal>
);

AddressDeleteModal.propTypes = {
  t: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  handleClose: PropTypes.func,
  handleDelete: PropTypes.func,
  company_name: PropTypes.string,
  label: PropTypes.string,
};

AddressDeleteModal.defaultProps = {
  handleClose: () => ({}),
  handleDelete: () => ({}),
  company_name: '',
  label: '',
};

export default AddressDeleteModal;
